<template>
  <v-select
    v-model="modelValue"
    v-bind="$attrs"
    v-validate="validations"
    :error-messages="errorMessages"
    :hide-details="true"
    :data-vv-as="displayName"
    :data-vv-name="inputIdentifier"
    :id="`select_${inputIdentifier}`"
    :items="items"
    :label="displayName"
    :name="inputIdentifier"
    :menu-props="{ auto: true }"
    outline />
</template>

<script>
import InputCommonMixin from '@/mixins/InputCommonMixin';

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [InputCommonMixin],
};
</script>
